import {
  BLOCKED_ERROR, FORBIDDEN_ERROR, INVALID_ERROR, SESSION_EXPIRED_ERROR,
} from '@/assets/AppConstants';
import { HTTP_STATUS_6XX } from '@/assets/constants/Http';

const SCREEN_STATUSES: ReadonlySet<number> = new Set([
  FORBIDDEN_ERROR, SESSION_EXPIRED_ERROR, BLOCKED_ERROR, INVALID_ERROR,
]);

// A missing task forbids that one action, not the screen: it gets an alert like any other refusal.
export const takesOverTheScreen = (status: number, code?: unknown): boolean =>
  SCREEN_STATUSES.has(status) && code !== HTTP_STATUS_6XX.UNAUTHORIZED_TASK;
